import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

import { defaultCaseWorkersSettings, CaseWorkersSettings } from '../../../../core/models';

@Component({
    selector: 'app-case-worker-settings',
    templateUrl: './case-worker-settings.component.html',
    styleUrls: ['./case-worker-settings.component.scss'],
    standalone: false
})
export class CaseWorkerSettingsComponent implements OnInit, OnChanges {

  @Input() settings: CaseWorkersSettings | undefined;
  @Output() saveSettings: EventEmitter<FormGroup> = new EventEmitter<FormGroup>();

  value: CaseWorkersSettings = {
    ...defaultCaseWorkersSettings
  };
  form: FormGroup = new FormGroup( {
    remove_delay: new FormControl<number>(this.value.remove_delay, [Validators.required, Validators.min(1)]),
    daily_reminder: new FormControl<boolean>(this.value.daily_reminder)
  });

  ngOnInit(): void {
    this.form.disable();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['settings']) {
      this.settings = changes['settings'].currentValue;
      if (this.settings) {
        this.value = { ...defaultCaseWorkersSettings, ...this.settings };
      }
      this.form.patchValue(this.value);
    }
  }

  doEdit(): void {
    this.form.enable();
  }

  doCancel(): void {
    this.value = { ...defaultCaseWorkersSettings, ...this.settings };
    this.form.reset(this.value);
    this.form.disable();
  }

  doSave(): void {
    this.saveSettings.emit(this.form);
    this.form.disable();
  }

}
